import { Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from "@angular/router";

import { v4 as uuidv4 } from 'uuid';

import { UrlService } from '@core/services/url/url.service';
import { VersionsService } from '@core/services/versions/versions.service';
import { RecorderService } from '@core/services/recorder/recorder.service';



import * as Objects from '@core/objects';
import { VersionFeedback } from '@core/models/version-feedback';
import { VersionShare } from '@core/models/version-share.model';
import { VersionShareFeedbackMessage, VersionShareFeedbackMessageType } from '@core/models/version-share-message.model';
import { VersionFeedbackMessage } from '@core/models/version-feedback-message';
// core recorder state 
import * as fromState from '@core/store/state/recorder/recorder.state';


@Component({
    selector: 'plugin-share-feedback-core-version-share-messages',
    templateUrl: './version-share-messages.component.html',
    styleUrls: ['./version-share-messages.component.scss']
})
export class PluginShareFeedbackCoreVersionShareMessagesComponent implements OnInit, OnChanges, OnDestroy {
    protected readonly PLUGIN_SHARE_FEEDBACK_CONTEXT = 'plugin-share-feedback';
    protected readonly PLUGIN_SHARE_UPLOAD_VERSION_CONTEXT = 'plugin-share-upload-version';
    public readonly VERSION_SHARE_MESSAGE_TYPE = VersionShareFeedbackMessageType;

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_FOUND = 3;

    @Input() version: Objects.Version = null;
    @Input() feedbacks: Array<VersionFeedback> = null;
    @Input() versionShares: Array<VersionShare> = null;
    @Input() versionShareMessages: Array<VersionShareFeedbackMessage> = null;
    @Input() user: Objects.User = null;
    @Input() addMessage: boolean = false;
    @Input() notesActionText: string;
    @Input() notesActionStyle: string;
    @Input() canCreateNotes: boolean = true;
    @Input() canDelete: boolean = true; // message
    @Input() filesUploadPrefix: string = '';
    @Input() prefixNotesUrl: string = '';

    public messagesList: Array<VersionShareFeedbackMessage> = null;
    public messages: Array<VersionFeedbackMessage> = null;
    public feedbackTextMessages: Array<Objects.Message> = null;
    public status: number = this.STATUS_LOADING;
    // for videomessage feature
    public context: string = this.PLUGIN_SHARE_UPLOAD_VERSION_CONTEXT;
    protected hash: string = '';
    // legacy variables
    public messageAddUrl: string;

    protected recorderSubscriptor: Subscription;

    constructor(private versionsSrv: VersionsService, private urlSrv: UrlService,
        private activeRoute: ActivatedRoute,
        private recorderSrv: RecorderService ) { }

    ngOnInit() {
        this.hash = this.activeRoute.snapshot.paramMap.get('hash')?.toString() || '';
        this.filesUploadPrefix += this.hash;
        // here we check the recorder status to reload messages
        this.recorderSubscriptor = this.recorderSrv.getStatus().subscribe((status: fromState.RecorderStatus ) => {
            if(status == fromState.RecorderStatus.FINISHED_SUCCESS){
                this.loadMessages();
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.version && this.version != null)
            this.init();
        if(changes.feedbacks && this.feedbacks != null){
            this.initApprovals();
        }
        if(changes.versionShareMessages && this.versionShareMessages != null){
            this.initApprovals();
        }
    }

    ngOnDestroy(): void {
        this.messagesList = null;
        this.recorderSubscriptor.unsubscribe();
    }

    protected init() {
        this.messageAddUrl = this.urlSrv.build("/versions/" + this.version.id + "/messages");
        this.status = this.STATUS_LOADING;
        // this.selectedFile = null;
        this.loadMessages();

    }

    protected initApprovals(){
        // let approvalList:VersionFeedbackMessage[] = (this.feedbacks?.length > 0) ? this.feedbacks.filter((f:VersionFeedback) => f.approval != null && f.approval.status_code != 0)
        //     .map((f:VersionFeedback) => {
        //         return {message: null, feedback: f, date:f.approval.date};
        //     }) : [];
        
        this.prepareMessages();
    }

    protected loadMessages(){
        // here we only load feedback regular text messages 
        this.versionsSrv.getMessages$(this.version).subscribe((messages: Array<Objects.Message>) => {
            if(messages != null){
                this.feedbackTextMessages = messages;
                this.messages = messages.map((m:Objects.Message) => {
                    return {message: m,feedback:null, date:m.date};
                });
                this.prepareMessages();
            }
        });
    }

    protected prepareMessages(){
        // dec-2023 case when we have new VersionShares
        if(this.feedbackTextMessages != null && this.versionShareMessages != null ){
            let msgList: VersionShareFeedbackMessage[]  =  this.feedbackTextMessages.map((msg: Objects.Message) => {
                let shares = (this.versionShares.length > 0) ? this.versionShares.filter((vs:VersionShare) => vs.entry.user.id == msg.user.id) : [];
                return {    
                    uuid: uuidv4(),
                    type: this.VERSION_SHARE_MESSAGE_TYPE.TEXT_MESSAGE_TYPE,
                    message: msg, 
                    user_version_shares: shares, 
                    date: msg.date,
                    version: this.version
                };
            });

            this.messagesList = [...this.versionShareMessages, ...msgList];
            this.status = this.STATUS_DONE
        }
    }

    public saveMessage(message: Objects.Message){
        this.loadMessages();
    }

    public messageDeleted(message: Objects.Message){
        // TODO with messagesSrv
        console.debug("message delete clicked ", message);
        this.loadMessages();
    }


}
